/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/tooltip/custom-elements';

import { defineCustomElement as defineOsdsTooltip } from '@ovhcloud/ods-stencil/components/tooltip/custom-elements/osds-tooltip.js';
import { defineCustomElement as defineOsdsTooltipContent } from '@ovhcloud/ods-stencil/components/tooltip/custom-elements/osds-tooltip-content.js';

export const OsdsTooltip = /*@__PURE__*/createReactComponent<JSX.OsdsTooltip, HTMLOsdsTooltipElement>('osds-tooltip', undefined, undefined, defineOsdsTooltip);
export const OsdsTooltipContent = /*@__PURE__*/createReactComponent<JSX.OsdsTooltipContent, HTMLOsdsTooltipContentElement>('osds-tooltip-content', undefined, undefined, defineOsdsTooltipContent);
